import { render } from "./QuestionnaireForm.vue?vue&type=template&id=181254b4&scoped=true"
import script from "./QuestionnaireForm.vue?vue&type=script&lang=js"
export * from "./QuestionnaireForm.vue?vue&type=script&lang=js"

import "./QuestionnaireForm.vue?vue&type=style&index=0&id=181254b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181254b4"]])

export default __exports__